import { useEffect, useState } from 'react';
import { signupOpen } from '../../api/plans';

/**
 * MVP-278 harden. Whether the server takes sign-ups (`SELF_SERVE_SIGNUP_ENABLED`), asked once:
 * null while asking, false on any failure — a link to a door that may be shut is not offered.
 */
export function useSignupOpen(): boolean | null {
  const [open, setOpen] = useState<boolean | null>(null);
  useEffect(() => {
    let live = true;
    signupOpen().then(
      (value) => live && setOpen(value),
      () => live && setOpen(false)
    );
    return () => {
      live = false;
    };
  }, []);
  return open;
}
